import { useEffect, useState } from 'react';
import { Fetch } from '../services/api';

export const useEmpresas = () => {
    const [ empresas, setEmpresas ] = useState([]);
    
    useEffect(()=>{
        listarEmpresas()
    },[])
    
    const listarEmpresas = async () => {
        const response = await Fetch({url:'https://xprojectwebapi.abexacloud.com/api/General/companies'})

        if (response.isValid) {
            setEmpresas(response.content)
        }
    }
    
    return {
        empresas,
        listarEmpresas, 
    }
}

